module.exports = __webpack_public_path__ + "img/rsini_1.f9973497.jpg";